import Vue from "vue";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

Vue.component("p-date-picker", VuePersianDatetimePicker);
